<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <!-- <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
                    <div
                        class="w-100 d-lg-flex align-items-center justify-content-center px-5"
                    >
                        <b-img fluid :src="imgUrl" alt="Login V2" />
                    </div>
                </b-col> -->
      <!-- /Left Text-->
      <!-- Login-->
      <b-col lg="4" class="login d-flex align-items-center px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <div
            class="d-flex justify-content-center align-items-center flex-column"
          >
            <img src="/media/svg/logo-resturant.svg" alt="" />
            <h4>اهلا بكم في لوحة التحكم</h4>
            <b-card-text class="mb-2"> يرجى تسجيل الدخول للمتابعة </b-card-text>
          </div>
          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              ref="loginForm"
              @submit.prevent
            >
              <!-- username -->
              <b-form-group
                class="position-relative input-form"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="الحقل اسم المستخدم"
                  rules="required"
                >
                  <unicon class="icon1" name="user"></unicon>
                  <b-form-input
                    id="login-username"
                    v-model="userName"
                    :state="errors.length > 0 ? false : null"
                    name="login-username"
                    placeholder="اسم المستخدم"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group class="position-relative input-form">
                <!-- <div class="d-flex justify-content-between">
                                    <label for="login-password"
                                        >كلمة المرور</label
                                    >
                                </div> -->
                <validation-provider
                  #default="{ errors }"
                  name="الحقل كلمة المرور"
                  rules="required"
                >
                  <unicon class="icon2" name="padlock"></unicon>
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="كلمة المرور"
                    />
                    <!-- <b-input-group-append is-text>
                                            <feather-icon
                                                class="cursor-pointer"
                                                :icon="passwordToggleIcon"
                                                @click="
                                                    togglePasswordVisibility
                                                "
                                            />
                                        </b-input-group-append> -->
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group
                class="mt-2 w-100 d-flex justify-content-end align-items-end"
              >
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  <span style="color: #fff"> تذكرني </span>
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <div
                class="w-100 d-flex justify-content-center align-items-center"
              >
                <b-button type="submit" @click="login"> تسجيل الدخول </b-button>
              </div>
              <div
                class="forget d-flex justify-content-center align-items-center"
              >
                <router-link to="/">استعادة الكلمة المرور</router-link>
                <span> هل نسيت كلمة المرور؟ </span>
              </div>
            </b-form>
            <div class="error-login mt-1">
              {{ errorMsg }}
            </div>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";

import useJwt from "./jwt/useJwt.js";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser, RoleClime } from "./utils";
import jwtDecode from "jwt-decode";
import { $themeConfig } from "@themeConfig";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  setup() {
    // App Name
    const { appName } = $themeConfig.app;
    return {
      appName,
    };
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: false,
      password: "",
      userName: "",
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      required,
      errorMsg: "",
    };
  },
  created() {
    localize("ar");
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    login() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          useJwt
            .login({
              userName: this.userName,
              password: this.password,
            })
            .then((response) => {
              const userData = response.data;
              useJwt.setToken(response.data.accessToken);
              // useJwt.setRefreshaccessToken(response.data.refreshaccessToken);
              localStorage.setItem("userData", JSON.stringify(userData));

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router
                .replace(
                  getHomeRouteForLoggedInUser(
                    jwtDecode(response.data.accessToken)[RoleClime]
                  )
                )
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: `مرحبا" ${userData.fullName}`,
                      icon: "CoffeeIcon",
                      variant: "success",
                      text: `تم تسجيل الدخول بنجاح. الأن يمكنك التصفح!`,
                    },
                  });
                })
                .catch((error) => {
                  this.errorMsg =
                    "كلمة السر خاطئة و اسم المستخدم غير متطابقين, يرجى المحاولة مرة أخرى";
                  console.log(error);
                });
            })
            .catch((err) => {
              this.errorMsg =
                "كلمة السر خاطئة و اسم المستخدم غير متطابقين, يرجى المحاولة مرة أخرى";
              console.log(err);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
// .blur-auth {

.auth-wrapper {
  background-image: url("https://images.pexels.com/photos/2894275/pexels-photo-2894275.jpeg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .auth-inner {
    width: 100%;
    height: 100%;
    background-color: #0075658c !important;
    // backdrop-filter: blur(3px);
    // position: relative !important;

    // .login {
    //     position: absolute !important;
    //     z-index: 9999 !important;
    // }
    h4 {
      font-weight: 700;
      font-size: 18px;
      line-height: 36px;
      color: #ffffff;
    }
    p.card-text {
      font-weight: 500;
      font-size: 16px;
      line-height: 32px;
      color: #ffffff;
    }
    .auth-login-form {
      .form-group.input-form input {
        // position: relative !important;
        height: 60px !important;
        padding: 20px 10px 20px 10px !important;
        background: rgba(255, 255, 255, 0.1) !important;
        border: 2px solid #ffffff !important;
        border-radius: 20px;
        color: #ffffff !important;
      }

      .unicon {
        position: absolute;
        z-index: 999;
        fill: #ffffff;
        right: 1.5rem;
        top: 1rem;
      }
    }

    button {
      background-color: #ffffff !important;
      border: none;
      padding: 25px;
      color: #007565 !important;
      border-radius: 20px;
      width: 200px;
    }
    .forget {
      margin-top: 3rem;
      span {
        color: #fff;
      }
      a {
        text-decoration: underline;
        margin-right: 5px;
        color: #ffffff !important;
      }
    }
    .error-login {
      color: red;
      font-size: 0.9rem;
    }
  }
}
</style>
